import { render, staticRenderFns } from "./DanielaCipriano.vue?vue&type=template&id=327877d8"
import script from "./DanielaCipriano.vue?vue&type=script&lang=js"
export * from "./DanielaCipriano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports